import React from 'react';
import { Anuncio } from '../../../../../entities/Marketing'


import {
    Button,
    Row,
    ListGroupItem,
    ListGroup,
} from "reactstrap";

interface IList {
    anuncios: Array<Anuncio>
    handleDelete(anuncio: Anuncio): Promise<void>
}

const List: React.FC<IList> = ({ anuncios, handleDelete }) => {

    return <ListGroup className="list mt-4" flush>
        {
            anuncios.map((item, key) => (
                <ListGroupItem
                    className="list-group-item-action px-0"
                    style={{ flexDirection: 'row', display: 'flex', flex: 1, alignItems: 'center' }}
                    key={key}>
                    <div className="col-auto">
                        <Button
                            className="btn-sm"
                            color="danger"
                            onClick={async (e) => {
                                e.preventDefault()
                                await handleDelete(item)
                            }}
                        >
                            <i className="fas fa-trash"></i>
                        </Button>
                    </div>
                    <Row
                        style={{ flex: 1 }}
                        className="align-items-center">
                        <div className="col">
                            <h4 className="mb-0">
                                <a href="#" onClick={e => e.preventDefault()}>
                                    {item?.nome}
                                </a>
                            </h4>
                            <small>{`${item.campanha?.nome}`}</small><br />
                        </div>

                    </Row>
                </ListGroupItem>
            ))
        }
    </ListGroup>
}

export default List;